import { areDimensionsOptionalForQuote, requiresMobileNumberBasedOnExtrasSelection } from './quotes';
import { BasketItem, BasketQuote, QuoteAddress, QuoteError, QuoteExtras, QuoteParcels } from './types/basket-types';
import { BasketSections } from './types/enums';

export function validateItem(id: string, item: BasketItem): QuoteError[] {
  const quote = item.sections[BasketSections.QUOTE]?.payload as BasketQuote;
  const quoteExtras = item.sections[BasketSections.EXTRAS]?.payload as QuoteExtras;
  const origin = item.sections[BasketSections.ORIGIN]?.payload as QuoteAddress;
  const parcels = item.sections[BasketSections.PARCELS]?.payload as QuoteParcels;

  const output: QuoteError[] = [];

  if (requiresMobileNumberBasedOnExtrasSelection(quote, quoteExtras.extras, origin)) {
    output.push({
      title: 'Phone number is missing',
      detail: 'We need to take a phone number for your text message notification.',
      type: 'UI-VALIDATION/ORIGIN_PHONE_REQUIRED_FOR_NOTIFICATION',
      itemId: id
    });
  }

  if (areDimensionsOptionalForQuote(quote) === false) {
    if (parcels.parcels.some((p) => !p.length || !p.width || !p.height)) {
      output.push({
        title: 'Parcel dimensions are missing',
        detail: 'We need to know the dimensions of your parcel to provide you with a quote.',
        type: 'UI-VALIDATION/PARCEL_DIMENSIONS_REQUIRED',
        itemId: id
      });
    }
  }

  return output;
}
